import type { NavigationElement } from './navigationElementMapper';

const mapNavigationElements = (navigationElements?: NavigationElement[] | null): NavigationElement[] | null => {
    if (!navigationElements?.length) {
        return null;
    }

    return navigationElements
        .filter((navigationElement: NavigationElement) => navigationElement.identifier !== 'category')
        .map((navigationElement: NavigationElement) => {
            if (navigationElement.identifier === 'becomeACustomer') {
                return {
                    ...navigationElement,
                    ...{
                        slug: 'kunde-werden'
                    }
                } as NavigationElement;
            }

            return {
                ...navigationElement,
                ...{
                    navigationElements: mapNavigationElements(navigationElement.navigationElements)
                }
            } as NavigationElement;
        });
};

const combinedNavigationElementMapper = (navigationElement: NavigationElement): NavigationElement => ({
    ...navigationElement,
    ...{
        navigationElements: mapNavigationElements(navigationElement?.navigationElements)
    }
});

export default combinedNavigationElementMapper;
